import React from "react";
import { useSelector } from "react-redux";
import avatar2 from "../../../assets/images/users/profile.png";

function Intro() {
  const { user } = useSelector((state) => state.User);
  return (
    <div className="card main_dashboard_intro">
      <div className="card-body">
        <div className="d-flex intro_row">
          <div className="col-left">
            <div className="user_main_image">
              <img
                src={user?.image ? user?.image : avatar2}
                alt={user?.name}
                className="img-fluid img-thumbnail img-rounded"
                style={{ borderRadius: "20px", maxHeight: 100 }}
              />
            </div>
          </div>
          <div className="col-right ps-4">
            <div className="d-flex flex-column justify-content-center h-100">
              <div className="user_main_info">
                <h4 className="mb-0">Welcome {user?.name}</h4>
                {user?.role && (
                  <span className="text-muted">
                    <strong>{user?.role?.title}</strong> at Info Salons
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Intro;
